import { dataTelephone } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTelephone = /*#__PURE__*/createIcon(dataTelephone)
export default IconTelephone
